import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LacFormatPipe } from '../lac-format/lac-format.pipe';
import { filterPipe } from '../search/search.pipe';
import { SortPipe } from '../Sort/sort.pipe';
import { TodayTommorowPipe } from '../todayTommorow/today-tommorow.pipe';



@NgModule({
  declarations: [LacFormatPipe, filterPipe, SortPipe, TodayTommorowPipe],
  imports: [
    CommonModule
  ],
  exports: [
    LacFormatPipe,
    filterPipe,
    SortPipe,
    TodayTommorowPipe
  ]
})
export class PipeModuleModule { }
